import React from 'react';
import { AppBar as MUIAppBar, Toolbar, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

// Components
import { BrandingStatCanEn } from '../BrandingStatCan';

const Root = styled('div')(({ theme }) => ({
  '& .app-bar': {
    zIndex: 1200,
    backgroundColor: theme.palette.common.white,
  },

  '& .app-bar__branding': {
    '& img': {
      height: theme.spacing(3),
    },
  },
}));

export default function AppBarError() {
  return (
    <Root>
      <MUIAppBar className="app-bar" color="default" position="sticky">
        <Toolbar component="nav">
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item className="app-bar__branding">
              <BrandingStatCanEn />
            </Grid>
          </Grid>
        </Toolbar>
      </MUIAppBar>
    </Root>
  );
}
